const OEMBED = 'https://open.spotify.com/oembed';

/**
 * Resolve a human-readable title for an open.spotify.com link (playlist, track, album, etc.).
 * Uses Spotify's public oEmbed API (CORS-friendly: Access-Control-Allow-Origin: *).
 * @param {string} url
 * @returns {Promise<string|null>}
 */
export async function fetchSpotifyOEmbedTitle(url) {
  try {
    const u = String(url).trim();
    if (!u) return null;
    const r = await fetch(`${OEMBED}?url=${encodeURIComponent(u)}`);
    if (!r.ok) return null;
    const j = await r.json();
    const title = j?.title;
    if (typeof title === 'string' && title.trim()) return title.trim().slice(0, 200);
    return null;
  } catch {
    return null;
  }
}
